import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export function useRequests(
  params: {
    page?: number;
    limit?: number;
    category?: string;
    search?: string;
  } = {},
  options: { enabled?: boolean } = {},
) {
  return useQuery({
    queryKey: ['requests', params],
    queryFn: () => api.getRequests(params),
    enabled: options.enabled ?? true,
  });
}

export function useRequestById(id: number) {
  return useQuery({
    queryKey: ['request', id],
    queryFn: () => api.getRequestById(id),
    enabled: !!id,
  });
}

export function useStats() {
  return useQuery({
    queryKey: ['stats'],
    queryFn: () => api.getStats(),
    refetchInterval: 60000, // Refresh every minute
  });
}

export function useRequestsByCategory(category: string, params: { page?: number; limit?: number } = {}) {
  return useQuery({
    queryKey: ['requests', 'category', category, params],
    queryFn: () => api.getRequestsByCategory(category, params),
    enabled: !!category && category !== 'all',
  });
}

export function useRequestHistory(id: number, enabled = true) {
  return useQuery({
    queryKey: ['request-history', id],
    queryFn: () => api.getRequestHistory(id),
    enabled: !!id && enabled,
  });
}
